import '@varlet/touch-emulator';
import '@/shared/styles/index.css';
import type { App as VueApp } from 'vue';

import { initUiComponents } from './components';

const initUiKit = (app: VueApp<Element>) => {
  initUiComponents(app);
};

export { initUiKit };
